import { fetchSettings } from './api/orders-client';
import type { BootstrapConfig, StoreSettings } from './types';

/**
 * Resolves store settings server-side (§2.8) so the Settings API origin
 * never lands in the browser bundle. In mock mode we shortcut with a
 * stub settings object.
 */
export async function resolveBootstrap(
  config: BootstrapConfig,
): Promise<{ settings: StoreSettings; xApiKey: string }> {
  if (config.mock) {
    return {
      xApiKey: 'mock',
      settings: {
        storeId: Number.isFinite(config.storeId) ? config.storeId : 0,
        httpUrl: 'https://mock.invalid',
        wsUrl: 'wss://mock.invalid',
        storeName: 'Mock Store',
        marketId: 0,
        marketName: 'Mock Market',
      },
    };
  }

  if (!Number.isFinite(config.storeId) || config.storeId <= 0) {
    throw new BootstrapError('Missing or invalid storeId in URL.');
  }
  if (!config.xApiKey) {
    throw new BootstrapError('Missing xApiKey in URL.');
  }

  const settings = await fetchSettings({ storeId: config.storeId });
  return { settings, xApiKey: config.xApiKey };
}

export class BootstrapError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BootstrapError';
  }
}
